<div class="flex flex-col">
    <div class="flex flex-col text-center py-24 px-[112px]">
        <span class="text-md font-semibold text-purple pb-3">Features</span>
        <h1 class="text-5xl pb-6">Plans that fit your scale
        </h1>
        <p class="text-xl text-gray-600  pb-12">Simple, transparent pricing that grows with you. Try any plan free for 30 days.
        </p>
        <div class="flex justify-center">
            <button class="ml-3 px-6 py-2 shadow rounded-3xl bg-white text-gray-900">Chat to Sales</button>
            <button class="ml-3 px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get started</button>
        </div>
    </div>
</div>

<div class="flex px-[112px] py-8 justify-between flex-wrap">
    <div class="flex flex-col justify-between border border-gray-200 rounded-[16px] shadow">
        <div class="flex flex-col items-center gap-2 mx-8 mt-8 pb-8 border-b border-gray-200">
            <div class="flex items-center gap-2 border border-gray-300 rounded-[6px] text-sm mb-6 p-1">
                <span class="flex items-center border border-gray-300 rounded-[6px] py-[2px] px-2">
                    <img class="p-[6px]"  [src]="assetUrl + 'icons/dot.svg'">
                    Basic plan
                </span>
            </div>
            <div class="text-center">
                <div class="text-5xl text-gray-900">$10/mth</div>
                <div>Our most popular plan.</div>
            </div>
        </div>
    
        <div class="flex flex-col gap-2 mx-8 pt-8 pb-8 border-b border-gray-200">
            <div class="flex items-center gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>
                <span>Access to all basic features</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>       
                <span>Basic reporting and analytics</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>       
                <span>Up to 20 individual users</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>        
                <span>20 GB individual data each user</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>
                <span>Basic chat and email support</span>
            </div>
        </div>
    
        <div class="flex p-8">
            <button class="ml-3 w-full px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get started</button>
        </div>
    </div>
    <div class="flex flex-col justify-between border border-gray-200 rounded-[16px] shadow">
        <div class="flex flex-col items-center gap-2 mx-8 mt-8 pb-8 border-b border-gray-200">
            <div class="flex items-center gap-2 border border-gray-300 rounded-[6px] text-sm mb-6 p-1">
                <span class="flex items-center border border-gray-300 rounded-[6px] py-[2px] px-2">
                    <img class="p-[6px]" [src]="assetUrl + 'icons/dot.svg'">
                    Business plan
                </span>
                <span class="text-purple pr-2">Most popular</span>
            </div>
            <div class="text-center">
                <div class="text-5xl text-gray-900">$20/mth</div>
                <div>Growing teams up to 20 users.</div>
            </div>
        </div>
    
        <div class="flex flex-col gap-2 mx-8 pt-8 pb-8 border-b border-gray-200">
            <div class="flex items-center gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>
                <span>200+ integrations</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>       
                <span>Advanced reporting and analytics</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>       
                <span>Up to 20 individual users</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>        
                <span>40 GB individual data each user</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>
                <span>Priority chat and email support</span>
            </div>
        </div>
    
        <div class="flex p-8">
            <button class="ml-3 w-full px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get started</button>
        </div>
    </div>
    <div class="flex flex-col justify-between border border-gray-200 rounded-[16px] shadow">
        <div class="flex flex-col items-center gap-2 mx-8 mt-8 pb-8 border-b border-gray-200">
            <div class="flex items-center gap-2 border border-gray-300 rounded-[6px] text-sm mb-6 p-1">
                <span class="flex items-center border border-gray-300 rounded-[6px] py-[2px] px-2">
                    <img class="p-[6px]"  [src]="assetUrl + 'icons/dot.svg'">
                    Enterprise plan
                </span>
            </div>
            <div class="text-center">
                <div class="text-5xl text-gray-900">$40/mth</div>
                <div>Advanced features + unlimited users.</div>
            </div>
        </div>

        <div class="flex flex-col gap-2 mx-8 pt-8 pb-8 border-b border-gray-200">
            <div class="flex items-center gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>
                <span>Advanced custom fields</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>       
                <span>Audit log and data history</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>       
                <span>Unlimited individual users</span>
            </div>
            <div class="flex items-start gap-2">
                <span>
                    <img [src]="assetUrl + 'icons/check.svg'">
                </span>        
                <span>Personalized + priority service</span>
            </div>
        </div>

        <div class="flex p-8">
            <button class="ml-3 w-full px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get started</button>
        </div>
    </div>
</div>

<!-- wide plans -->
<div class="flex flex-wrap gap-x-6 gap-y-6 px-[112px] py-8">
    <div class="w-full md:basis-[48%] flex flex-col justify-between border border-gray-200 rounded-[16px] shadow">
      <div class="flex flex-col items-center gap-2 mt-8 pb-8 border-b border-gray-200">
        <div class="flex items-center gap-2 border border-gray-300 rounded-[6px] text-sm mb-6 p-1">
          <span class="flex items-center border border-gray-300 rounded-[6px] py-[2px] px-2">
            <img class="p-[6px]" [src]="assetUrl + 'icons/dot.svg'">
            Basic plan
          </span>
        </div>
        <div class="text-center">
          <div class="text-5xl text-gray-900">$10/mth</div>
          <div>Growing teams up to 20 users.</div>
        </div>
      </div>
  
      <div class="flex flex-col gap-2 pt-8 pb-8 border-b border-gray-200 px-8">
        <div class="flex items-center gap-2">
          <img [src]="assetUrl + 'icons/check.svg'">
          <span>200+ integrations</span>
        </div>
        <div class="flex items-start gap-2">
          <img [src]="assetUrl + 'icons/check.svg'">
          <span>Advanced reporting and analytics</span>
        </div>
        <div class="flex items-start gap-2">
          <img [src]="assetUrl + 'icons/check.svg'">
          <span>Up to 20 individual users</span>
        </div>
        <div class="flex items-start gap-2">
          <img [src]="assetUrl + 'icons/check.svg'">
          <span>40 GB individual data each user</span>
        </div>
        <div class="flex items-start gap-2">
          <img [src]="assetUrl + 'icons/check.svg'">
          <span>Priority chat and email support</span>
        </div>
      </div>
  
      <div class="p-8">
        <button class="w-full px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get started</button>
      </div>
    </div>
  
    <div class="w-full md:basis-[48%] flex flex-col justify-between border border-gray-200 rounded-[16px] shadow">
      <div class="flex flex-col items-center gap-2 mt-8 pb-8 border-b border-gray-200">
        <div class="flex items-center gap-2 border border-gray-300 rounded-[6px] text-sm mb-6 p-1">
          <span class="flex items-center border border-gray-300 rounded-[6px] py-[2px] px-2">
            <img class="p-[6px]" [src]="assetUrl + 'icons/dot.svg'">
            Enterprise plan
          </span>
        </div>
        <div class="text-center">
          <div class="text-5xl text-gray-900">$40/mth</div>
          <div>Growing teams up to 20 users.</div>
        </div>
      </div>
  
    <div class="flex flex-col gap-2 mx-8 pt-8 pb-8 border-b border-gray-200">
        <div class="flex items-center gap-2">
            <span>
                <img [src]="assetUrl + 'icons/check.svg'">
            </span>
            <span>Advanced custom fields</span>
        </div>
        <div class="flex items-start gap-2">
            <span>
                <img [src]="assetUrl + 'icons/check.svg'">
            </span>       
            <span>Audit log and data history</span>
        </div>
        <div class="flex items-start gap-2">
            <span>
                <img [src]="assetUrl + 'icons/check.svg'">
            </span>       
            <span>Unlimited individual users</span>
        </div>
        <div class="flex items-start gap-2">
            <span>
                <img [src]="assetUrl + 'icons/check.svg'">
            </span>        
            <span>Personalized + priority service</span>
        </div>
    </div>
  
      <div class="p-8">
        <button class="w-full px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get started</button>
      </div>
    </div>
  </div>
  
<landing-start-booking></landing-start-booking>